export enum EventHomeMessage{
    operateRecordClick = "event_home_message_operate_record_click", // 操作日志弹窗
    uploadFileClick = "event_home_message_upload_file_click", // 上传文件弹窗
    changeFileName = "event_home_message_change_file_name", // 修改文件名
    closeUploadFilePopup = "event_home_message_clear_upload_file_popup", // 清除上传文件弹窗
}

export enum EventRenderProgressMessage{
    renderProgressComplete = "event_render_progress_complete", // 渲染进度完成
    wasmLoadProgress = "event_wasm_load_progress", // WASM 加载进度
    wasmLoadComplete = "event_wasm_load_complete", // WASM 加载完成
}

export enum EventEditorHomeBottom{
    editorHomeBottom = "event_editor_home_bottom", // 编辑器底部点击
}